import { Box } from '@mui/material';
import { Icon } from '@iconify/react';
import ReactLoading from 'react-loading';
import React from 'react';

const LoadingIcon: React.FC<{ loading: boolean }> = ({ loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          width: '20px',
          height: '20px',
          backgroundColor: '#535659',
          display: 'flex',
          justifyContent: 'center',
          alingItems: 'center',
          borderRadius: '5px',
        }}
      >
        <Box sx={{ mt: '1px' }}>
          <ReactLoading type="spokes" color="#7AED20" width="13px" />
        </Box>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: '20px',
          height: '20px',
          backgroundColor: '#7AED20',
          display: 'flex',
          justifyContent: 'center',
          alingItems: 'center',
          borderRadius: '5px',
        }}
      >
        <Icon
          icon="eva:checkmark-fill"
          color="white"
          style={{ marginTop: '2px' }}
        />
      </Box>
    );
  }
};

export default LoadingIcon;
